module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('conjuntoAtributo.titulos.titulo'),
      "subTitle": _vm.$t('conjuntoAtributo.titulos.subtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('conjuntoAtributo.labels.novoConjunto'),
      "id": "btnCriarNovoConjuntoAtributo",
      "clickFunction": _vm.newAttribute,
      "title": _vm.attributesSet && _vm.attributesSet.length == _vm.linkTypes.length ? _vm.$t('conjuntoAtributo.labels.cadastroBloquado') : _vm.$t('conjuntoAtributo.labels.cadastro'),
      "disabled": !_vm.canCreate
    },
    slot: "new-button"
  }), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    attrs: {
      "id": "attributesSet"
    }
  }, [(_vm.attributesSet && _vm.attributesSet.length > 0) ? _c('div', [_c('div', {
    staticClass: "categories-header att-header"
  }, [_c('div', {
    staticClass: "categories-header-column-left col-xs-3 col-sm-3 col-md-3 col-lg-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipoVinculo'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-4 col-lg-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.quantidadeAtributos'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-1 col-lg-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.attributesSet), function(attributeSet) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": attributeSet,
        "clickFunction": _vm.createEditAttribute,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": attributeSet,
        "id": attributeSet.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.resultadoVazio'))
    }
  })])])], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveAttSet"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverPlan",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverAttCfg",
      "clickFunction": _vm.removeAttSet
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2de24fd3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de24fd3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/attributesSet/list.pug
// module id = 1391
// module chunks = 0